export interface CreatedAction<T> {
  type: string;
  payload: T;
}

export const createAction = <T>(type: string) => (payload: T = {} as T): CreatedAction<T> => ({
  type,
  payload,
});
